<template>
  <div class="photo-cell" v-if="photoList.length">
    <el-image
      v-for="(src, index) in previewList"
      :key="index"
      :src="src"
      :preview-src-list="previewList"
      :initial-index="index"
      fit="cover"
      class="photo-cell__img"
      lazy
    />
    <span v-if="extraCount > 0" class="photo-cell__extra">+{{ extraCount }}</span>
  </div>
  <span v-else class="photo-cell__empty">无照片</span>
</template>

<script>
const MAX = 3;

export default {
  name: 'PhotoCell',
  props: {
    photos: { type: [String, Array], default: '' },
  },
  computed: {
    photoList() {
      if (Array.isArray(this.photos)) return this.photos.filter(Boolean);
      if (!this.photos) return [];
      return String(this.photos)
        .split(/\r?\n/)
        .map((s) => s.trim())
        .filter(Boolean);
    },
    previewList() {
      return this.photoList;
    },
    visibleList() {
      return this.photoList.slice(0, MAX);
    },
    extraCount() {
      const len = this.photoList.length;
      return len > MAX ? len - MAX : 0;
    },
  },
};
</script>

<style lang="less" scoped>
.photo-cell {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  &__img {
    width: 36px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    background: #f5f7fa;
    object-fit: cover;
  }
  &__extra {
    color: #909399;
    font-size: 12px;
    margin-left: 2px;
  }
  &__empty {
    color: #c0c4cc;
    font-size: 12px;
  }
}
</style>
